import { render, staticRenderFns } from "./PriorityRules.vue?vue&type=template&id=11205127&"
import script from "./PriorityRules.vue?vue&type=script&lang=ts&"
export * from "./PriorityRules.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports